<template>
  <div class="introduction">
    <!--  资源概览  -->
    <div class="introduction-div__resource">
      <div class="base-flex__between base-flex__cross-center resource__div">
        <span>{{ $t('dashboard.overview') }}</span>
        <div>
          <el-dropdown class="base-margin__right-20" @command="openSettings">
            <el-button>
              {{ $t('dashboard.settings') }}<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :disabled="isOwner === 0" command="teamSetting">{{
                  $t('dashboard.teamSettings')
                }}
              </el-dropdown-item>
              <el-dropdown-item v-if="loginType === 'qq' && isOwner === 1" command="aksk">{{
                  $t('dashboard.projectKey')
                }}
              </el-dropdown-item>
              <el-dropdown-item :disabled="true" command="license">{{
                  $t('dashboard.generateLicense')
                }}
              </el-dropdown-item>
              <el-dropdown-item
                v-if="(projectDeleteInfo.subclusterList === 0 || projectDeleteInfo.env === '' ) && isOwner === 1"
                command="team"
              >
                {{ $t('dashboard.deleteTeam') }}
              </el-dropdown-item>
              <el-dropdown-item v-if="isOwner === 0" command="quitTeam">{{
                  $t('dashboard.quitTeam')
                }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>

      <div class="base-flex__between resource__node">
        <div><p>{{ $t('dashboard.nodeTotal') }}</p><span>{{
            nodeData.nodeNumber
          }}</span>{{ $t('dashboard.unit.count') }}
        </div>
        <div><p>{{ $t('dashboard.subclusterCount') }}</p><span>{{
            nodeData.subclusterTotalCount
          }}</span>{{ $t('dashboard.unit.count') }}
        </div>
        <div><p>{{ $t('dashboard.subclusterNodeTotal') }}</p><span>{{
            nodeData.subclusterNodeTotalCount
          }}</span>{{ $t('dashboard.unit.count') }}
        </div>
        <div><p>{{ $t('dashboard.masterNode') }}</p><span>{{
            nodeData.masterNodeTotalCount
          }}</span>{{ $t('dashboard.unit.count') }}
        </div>
        <div><p>{{ $t('dashboard.elasticNode') }}</p><span>{{
            nodeData.batchNodeTotalCount
          }}</span>{{ $t('dashboard.unit.count') }}
        </div>
        <div><p>{{ $t('dashboard.clusterNode') }}</p><span>{{
            nodeData.slurmNodeTotalCount
          }}</span>{{ $t('dashboard.unit.count') }}
        </div>
        <div><p>{{ $t('dashboard.cfsUsage') }}</p><span>{{ nodeData.cfsUsage }}</span>{{ $t('dashboard.unit.mib') }}
        </div>
        <div><p>{{ $t('dashboard.cosUsage') }}</p><span>{{ nodeData.cosUsage }}</span>{{ $t('dashboard.unit.mib') }}
        </div>
      </div>
    </div>

    <!--  按钮组  -->
    <div class="base-text-align__right button_margin_bo">
      <el-radio-group v-model="executeType" @change="onExecuteType">
        <el-radio-button label=0>{{ $t('dashboard.elasticTask') }}</el-radio-button>
        <el-radio-button label=1>{{ $t('dashboard.clusterTask') }}</el-radio-button>
      </el-radio-group>
    </div>

    <!--  表格  -->
    <div class="introduction-div__table">
      <!--<el-button class="viewAll" type="text" @click="viewAll">{{ $t('dashboard.viewAll') }}</el-button>-->
      <el-table :data="tableData" class="introduction-div__el-table">
        <el-table-column :label="$t('dashboard.taskName')" prop="Name"></el-table-column>
        <el-table-column :label="$t('dashboard.status')" prop="Status">
          <template slot-scope="scope">
            <el-tag :type="String(scope.row.Status) === taskStatusLineUp?'warning':''">
              {{ String(scope.row.Status) === taskStatusLineUp ? $t('dashboard.queuing') : $t('dashboard.running') }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column :label="$t('dashboard.runningResources')" prop="CvmInstanceType">
          <template slot-scope="scope">
            {{
              scope.row.BatchExperiment !== null ?
                `${scope.row.BatchExperiment.InstanceCoreType}-${scope.row.BatchExperiment.InstanceType}` : '-'
            }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('dashboard.startTime')" prop="CreateTime">
          <template slot-scope="scope">
            {{ scope.row.CreateTime }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('dashboard.runningTime')" prop="ComputeTime">
          <template slot-scope="scope">
            {{ computeTimeFilter(scope.row.ComputeTime) }}
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 40]"
        :total="totalCount"
        class="introduction-div__el-pagination"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange">
      </el-pagination>
    </div>

    <!--   录入aksk并保存   -->
    <ExamineAKSK :examineAKSKVisible="examineAKSKVisible" :examineAKSKVisibleFalse="examineAKSKVisibleFalse"/>

    <!--清空节点数据 创建节点过程 步骤 -->
    <MasterNodeAction ref="masterNodeAction"/>

    <el-dialog
      :title="$t('dashboard.tencentCloudInfo')"
      :visible.sync="dialogVisible"
      width="700px"
    >
      <el-form :label-width="'150px'">
        <el-form-item :label="$t('dashboard.ownerUin')">
          <div>{{ accountExistInfo.ownerUin }}</div>
        </el-form-item>
        <el-form-item :label="$t('dashboard.uin')">
          <div>{{ accountExistInfo.uin }}</div>
        </el-form-item>
        <el-form-item :label="$t('dashboard.secretId')">
          <div>{{ accountExistInfo.secretId }}</div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="isEdit">{{ $t('dashboard.confirm') }}</el-button>
      </span>
    </el-dialog>

    <!--  计算集群所有环境 弹窗  -->
    <el-dialog :close-on-click-modal="false"
               :modal-append-to-body="false"
               :title="$t('dashboard.clusterEnvironments')"
               :visible.sync="projectEnvDialogVisible"
               class="projectEnvInfo"
               width="500px">
      <div v-loading="projectEnvLoading" style="min-height: 300px">
        <el-tabs v-model="tabsActiveName">
          <el-tab-pane v-for="(item, index) in getProjectEnvList" :key="item.id"
                       :label="item.region" :name="item.region">
            <el-form :label-width="100">
              <el-form-item :label="$t('dashboard.cosBucket')">
                <div class="base-flex__between">
                  <span>{{ item.cosBucket }}</span>
                  <span>
                    <el-button
                      :disabled="item.cosBucket === ''"
                      type="text"
                      @click="clearResource('cos','cosBucket', item.region, index, 'cos:DeleteBucket ')"
                    >
                      {{ $t('dashboard.clearResources') }}
                    </el-button>
                  </span>
                </div>
              </el-form-item>
              <el-form-item :label="$t('dashboard.cfs')">
                <div class="base-flex__between">
                  <span>{{ item.cfsId }}</span>
                  <span>
                    <el-button
                      :disabled="item.cfsId === ''"
                      type="text"
                      @click="clearResource('cfs', 'cfsId', item.region, index, 'cfs:DeleteCfsFileSystem')"
                    >
                      {{ $t('dashboard.clearResources') }}
                    </el-button>
                  </span>
                </div>
              </el-form-item>
              <el-form-item :label="$t('dashboard.cfsSecurityGroup')">
                <div class="base-flex__between">
                  <span>{{ item.cfsGroupId }}</span>
                  <span>
                    <el-button
                      :disabled="item.cfsGroupId === ''"
                      type="text"
                      @click="clearResource('cfsSecurityGroup', 'cfsGroupId', item.region, index, 'cfs:DeleteCfsPGroup')"
                    >
                      {{ $t('dashboard.clearResources') }}
                    </el-button>
                  </span>
                </div>
              </el-form-item>
              <el-form-item :label="$t('dashboard.securityGroup')">
                <div class="base-flex__between">
                  <span>{{ item.securityGroupId }}</span>
                  <span>
                    <el-button
                      :disabled="item.securityGroupId === ''"
                      type="text"
                      @click="clearResource('securityGroup', 'securityGroupId', item.region, index, 'vpc:DeleteSecurityGroup')"
                    >
                      {{ $t('dashboard.clearResources') }}
                    </el-button>
                  </span>
                </div>
              </el-form-item>
              <el-form-item :label="$t('dashboard.vpc')">
                <div class="base-flex__between">
                  <span>{{ item.vpcId }}</span>
                  <span>
                    <el-button
                      :disabled="item.vpcId === ''"
                      type="text"
                      @click="clearResource('vpc', 'vpcId', item.region, index, 'vpc:DeleteVpc')"
                    >
                      {{ $t('dashboard.clearResources') }}
                    </el-button>
                  </span>
                </div>
              </el-form-item>
            </el-form>
            <div style="float: right">
              <el-button :disabled="item.vpcId !== ''" type="primary" @click="openSettings('team')">
                {{ $t('dashboard.deleteTeam') }}
              </el-button>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {getRequest, postRequest} from '@/common/libs/request';
import {ComputeTimeFilter} from '@/common/utils/utils';
import ExamineAKSK from '@/components/examineAKSK/index.vue';
import {mapGetters, mapState} from 'vuex';
import {
  ENV_STATUS_FAIL,
  ENV_STATUS_INIT,
  ENV_STATUS_SUCCESS,
  projectEnvStatusCleared,
  projectEnvStatusClearing,
  projectEnvStatusTerminated,
  TASK_STATUS_LINE_UP,
} from '@/common/constants';
import Cookies from 'js-cookie';
import {Message} from 'element-ui';
import MasterNodeAction from '@/components/masterNodeAction/index.vue';

export default {
  name: 'introduction',
  components: {
    ExamineAKSK,
    MasterNodeAction,
  },
  data() {
    return {
      dialogVisible: false,
      nodeData: {
        masterNodeTotalCount: '-',
        batchNodeTotalCount: '-',
        slurmNodeTotalCount: '-',
        cfsUsage: '-',
        cosUsage: '-',
        subclusterTotalCount: '-',
        subclusterNodeTotalCount: '-',
        nodeNumber: '-',
      },
      tableData: [],
      projectId: 0,
      currentPage: 1,
      registerNode: false,
      pageLimit: 10,
      executeType: 0,
      totalCount: 0,
      taskStatusLineUp: TASK_STATUS_LINE_UP,
      projectEnvStatusCleared,
      ENV_STATUS_INIT,
      ENV_STATUS_FAIL,
      projectEnvStatusTerminated,
      projectEnvStatusClearing,
      isOwner: 0,
      currentProject: {},
      defaultNodeData: {
        masterNodeTotalCount: 0,
        batchNodeTotalCount: 0,
        slurmNodeTotalCount: 0,
        cfsUsage: 0,
        cosUsage: 0,
        subclusterTotalCount: 0,
        subclusterNodeTotalCount: 0,
        nodeNumber: 0,
      },
      examineAKSKVisible: false,
      loginType: sessionStorage.getItem('loginType'),
      accountExistInfo: {},
      getProjectEnvList: [],
      projectEnvDialogVisible: false,
      projectEnvLoading: false,
      tabsActiveName: '',
      projectDeleteInfo: {
        env: {},
        subclusterList: 0,
      },
    };
  },
  async mounted() {
    window.sessionStorage.setItem('executeType', this.executeType);
    this.loginType = sessionStorage.getItem('loginType');
    const currentProject = this.getCurrentProject();
    this.projectId = currentProject.id;
    this.isOwner = currentProject.isOwner;
    this.getProjectEnv(currentProject);
    await this.getResource();
    await this.getList();
  },
  computed: {
    ...mapState(['app']),
    ...mapGetters('app', ['getCurrentProject']),
  },
  watch: {
    'app.currentProject': {
      immediate: true,
      handler(val) {
        if (val && val.env?.status) {
          this.registerNode = val.env.status === ENV_STATUS_SUCCESS;
          this.getProjectEnv(this.getCurrentProject());
          this.isOwner = val.isOwner;
          if (val.id !== this.projectId) {
            this.projectId = val.id;
            this.getResource();
            this.getList();
          } else {
            this.nodeData = this.defaultNodeData;
          }
        } else {
          this.nodeData = this.defaultNodeData;
        }
        this.isOwner = val.isOwner;
      },
    },
  },
  methods: {
    openSettings(command) {
      switch (command) {
        case 'aksk':
          this.checkProjectTencentAccountExist();
          break;
        case 'teamSetting':
          this.teamSetting();
          break;
        case 'team':
          this.deleteProject();
          break;
        case 'secretKey':
          this.$router.push('secretKey');
          break;
        case 'quitTeam':
          this.quitTeam();
          break;
      }
    },
    quitTeam() {
      this.$confirm(this.$t('dashboard.prompts.quitTeamConfirm'), this.$t('dashboard.prompts.title'), {
        confirmButtonText: this.$t('dashboard.prompts.ok'),
        cancelButtonText: this.$t('dashboard.prompts.cancel'),
        type: 'warning',
      }).then(() => {
        postRequest('/api/eda/common/project/exitTeam').then(() => {
          Cookies.remove('CurrentProjectId');
          window.sessionStorage.removeItem('currentProject');
          Message.success(this.$t('dashboard.prompts.quitTeamSuccess'));
          this.$store.dispatch('app/getProjectList');
          this.getResource();
          this.getList();
        });
      });
    },
    teamSetting() {
      this.$store.commit('app/setTeamIsShow', {
        isShow: true,
        action: 'modifyProjectInfo',
      });
    },
    isEdit() {
      this.dialogVisible = false;
      if (this.currentProject.isOwner === 1) {
        this.examineAKSKVisible = true;
      }
    },
    checkProjectTencentAccountExist() {
      if (this.loginType === 'qq') {
        postRequest('/api/eda/common/eda/checkProjectTencentAccountExist', {
          isOwner: this.currentProject.isOwner === 1,
        }).then((res) => {
          this.accountExistInfo = res;
          this.dialogVisible = true;
        })
          .catch(() => {
            if (this.currentProject.isOwner === 1) {
              this.examineAKSKVisible = true;
            }
          });
      }
    },
    examineAKSKVisibleFalse() {
      this.examineAKSKVisible = false;
    },
    getProjectEnv(data) {
      postRequest('/api/eda/common/subcluster/getSubclusterList', {limit: 999, offset: 0}).then((res) => {
        this.projectDeleteInfo.subclusterList = res?.totalCount || 0;
      });
      getRequest('/api/eda/common/project/getProjectEnv').then((res) => {
        data.env = res.env || '';
        this.projectDeleteInfo.env = res.env || '';
        this.currentProject = data;
      });
    },
    async deleteProject() {
      const res = await postRequest('/api/eda/common/project/getProjectEnvList', {
        offset: 0,
        limit: 10,
      }) || [];
      let result = true;
      if (res?.list && res?.list?.length !== 0) {
        res?.list.forEach((item) => {
          if (item.cfsId !== '' || item.cfsGroupId !== '' || item.securityGroupId !== '' || item.vpcId !== '' || item.cosBucket !== '') {
            result = false;
          }
        });
      }

      if (result) {
        this.$confirm(this.$t('dashboard.prompts.deleteTeamConfirm'), this.$t('dashboard.deleteTeam'), {
          confirmButtonText: this.$t('dashboard.prompts.ok'),
        }).then(() => {
          postRequest('/api/eda/common/project/destroyProject').then(() => {
            this.projectEnvDialogVisible = false;
            Cookies.remove('CurrentProjectId');
            window.sessionStorage.removeItem('currentProject');
            Message.success(this.$t('dashboard.prompts.deleteTeamSuccess'));
            this.$store.dispatch('app/getProjectList');
            this.getResource();
            this.getList();
          });
        });
      } else {
        Message.error(this.$t('dashboard.prompts.teamNotEmpty'));
      }
    },
    async getResource() {
      try {
        const nodeData = await postRequest('/api/eda/common/project/describeStatistics');
        nodeData.nodeNumber = nodeData.masterNodeTotalCount + nodeData.batchNodeTotalCount + nodeData.slurmNodeTotalCount + nodeData.subclusterNodeTotalCount || 0;
        this.nodeData = nodeData || this.defaultNodeData;
      } catch (e) {
        this.nodeData = this.defaultNodeData;
      }
    },
    async getList() {
      console.log('getlist');
      // getRequest(`https://eda-static-cdn-1300241787.file.myqcloud.com/build/api/public/thpcSellInstanceTypeList.json?t=${new Date().getTime()}`).then((res) => {
      //   console.log(res, 'res');
      // }).catch(() => {
      //   console.log('err');
      // });
      // const offset = this.pageLimit * (this.currentPage - 1);
      // const data = {
      //   Offset: offset,
      //   executeType: Number(this.executeType),
      //   limit: this.pageLimit,
      //   filters: [{
      //     name: 'status',
      //     values: [TASK_STATUS_RUNNING, TASK_STATUS_LINE_UP, TASK_STATUS_CREATING],
      //   }],
      // };
      // try {
      //   const res = await postRequest('/api/eda/common/experiment/getList', data);
      //   this.tableData = res?.experiments || [];
      //   this.totalCount = res?.totalCount || 0;
      // } catch (e) {
      // }
    },
    handleSizeChange(val) {
      this.pageLimit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.$nextTick(() => {
        this.currentPage = val;
        this.getList();
      });
    },
    viewAll() {
      this.$eventBus.$emit('viewAll');
    },
    onExecuteType() {
      window.sessionStorage.setItem('executeType', this.executeType);
      this.getList();
    },
    computeTimeFilter(val) {
      return ComputeTimeFilter(val);
    },
  },
};
</script>

<style lang="scss" scoped>
.introduction {
  font-family: PingFang SC;
  font-size: 14px;
  min-width: 895px;
}

.introduction-div__resource {
  background: #FFFFFF;
  height: 211px;
  padding: 24px 22px 0px;
  margin-bottom: 10px;

  .resource__div {
    margin-bottom: 28px;

    span {
      font-size: 16px;
    }

    button {
      width: 120px;
      height: 30px;
      padding: 0;
    }
  }

  .resource__node {
    div > p {
      margin-bottom: 16px;
    }

    span {
      font-size: 36px;
    }
  }
}

.introduction-div__table {
  margin-top: 10px;
  background: #FFFFFF;
  height: 386px;
  position: relative;

  ::v-deep .has-gutter {
    height: 45px;
    font-size: 14px;
  }

  .viewAll {
    position: absolute;
    top: 3px;
    right: 22px;
    z-index: 1;
  }

  .introduction-div__el-table {
    height: 322px;
  }

  .introduction-div__el-pagination {
    height: 64px;
    display: flex;
    align-items: center;
    justify-content: right;
    padding-right: 22px;
  }
}

.projectEnvInfo {
  ::v-deep .el-dialog__body {
    padding-top: 0;
  }
}

.button_margin_bo {
  margin-top: 26px;

  ::v-deep .el-radio-button__orig-radio:checked + .el-radio-button__inner {
    background: #0052D9;
  }
}
</style>
